import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { InputSlider } from '../../components/ui/inputSlider';
const useStyles = makeStyles({
    GridRoot: {
        minWidth: 56
    }
});
export const EditMatchResultSetPoints = props => {
    const classes = useStyles();
    const [teamSetPoints, setTeamSetPoints] = React.useState({ team1SetPoints: props.team1SetPoints, team2SetPoints: props.team2SetPoints });
    const [autoChangeSetPoints, setAutoChangeSetPoints] = React.useState(false);
    const handleOnChangeForPoints = (team1Points, team2Points, teamIndex) => {
        const setPointsForOppositeTeam = (pointsToSetFrom) => {
            if (pointsToSetFrom === 30)
                return 29;
            let pointsToSet = pointsToSetFrom <= 19 ? 21 : pointsToSetFrom + 2;
            pointsToSet = pointsToSet > 30 ? 30 : pointsToSet;
            return pointsToSet;
        };
        if (autoChangeSetPoints) {
            if (teamIndex === 1) {
                team2Points = setPointsForOppositeTeam(team1Points);
            }
            else if (teamIndex === 2) {
                team1Points = setPointsForOppositeTeam(team2Points);
            }
        }
        setTeamSetPoints({ team1SetPoints: team1Points, team2SetPoints: team2Points });
        props.onChange(team1Points, team2Points);
    };
    const handleFocus = (teamIndex) => {
        if (teamIndex === 1)
            setAutoChangeSetPoints(!teamSetPoints.team2SetPoints);
        if (teamIndex === 2)
            setAutoChangeSetPoints(!teamSetPoints.team1SetPoints);
    };
    return (React.createElement(Grid, { container: true, justify: "center", alignItems: "center", classes: { root: classes.GridRoot } },
        React.createElement(Grid, null,
            React.createElement(InputSlider, { sliderVisiblePerDefault: false, min: 0, max: 30, value: teamSetPoints.team1SetPoints || undefined, onFocus: () => handleFocus(1), onChange: (newVal) => handleOnChangeForPoints(newVal, teamSetPoints.team2SetPoints, 1) })),
        React.createElement(Grid, null, "\u00A0-\u00A0"),
        React.createElement(Grid, null,
            React.createElement(InputSlider, { sliderVisiblePerDefault: false, min: 0, max: 30, value: teamSetPoints.team2SetPoints || undefined, onFocus: () => handleFocus(2), onChange: (newVal) => handleOnChangeForPoints(teamSetPoints.team1SetPoints, newVal, 2) }))));
};
